import {combineReducers} from 'redux'
import opportunitiesView from './opportunitiesView'
import leadsView from './leadsView'
import sellingView from './sellingView'
import wonView from './wonView'
import salesAnalysisView from './salesAnalysisView'
import successStats from './successStats'
import types from 'actions/types'
import {WHOLE_COMPANY_TEAM_ID} from 'helpers/teams'

export const userOrTeam = (state = null, action) => {
    switch (action.type) {
        case types.SALES_UPDATE_USER_OR_TEAM:
            return action.userOrTeam
        case types.SALES_TOGGLE_DORMANTS:
            return WHOLE_COMPANY_TEAM_ID
        default:
            return state
    }
}

export const jobTypes = (state = null, action) => {
    switch (action.type) {
        case types.SALES_UPDATE_JOB_TYPES:
            return action.jobTypes
        default:
            return state
    }
}


export const showDormants = (state = false, action) => {
    switch (action.type) {
        case types.SALES_TOGGLE_DORMANTS:
            return action.showDormants
        default:
            return state
    }
}

export default combineReducers({
    opportunitiesView,
    leadsView,
    sellingView,
    wonView,
    salesAnalysisView,
    successStats,
    userOrTeam,
    jobTypes,
    showDormants,
})
